import styled from "styled-components";

export const HeaderComponent = styled.div.attrs({ lang: "tr" })`
	font-size: clamp(16px, 1.4vw, 22px);
	font-weight: 700;
	line-height: 1.4;
	letter-spacing: clamp(0.12em, 0.25vw, 0.3em);
	text-transform: uppercase;
	text-align: center;
	text-wrap: balance;
	overflow-wrap: anywhere;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	margin-bottom: 24px;
	padding-bottom: 12px;
	position: relative;
	color: #1a202c;
	font-family: "Roboto", "Roboto-Medium" !important;

	&::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 100px;
		height: 3px;
		border-radius: 2px;
		background: #f4511e;
	}
`;

export const ActionButtonOverlay = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const SubmitButtonOverlay = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
	margin-top: 24px;
	padding: 0 0 23px 0;
`;

export const Container = styled.div`
    background-color: white;
    padding: 24px;
`;

export const ContainerHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: 69px;
	background-color: #e4e7ed;
	padding: 1.25rem;
`;

export const StatusCell = styled.div<{ $bool: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ $bool }) =>
		$bool ? "#eaffef" : "#ffeaea"};
	color: ${({ $bool }) => ($bool ? "#40c965" : "#c94040")};
	width: 103px;
	height: 24px;
	font-weight: normal;
	font-family: "Roboto";
`;

export const ActionContainer = styled.main`
	background: #fff;
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const FiltersContainer = styled.div`
	margin-right: 20px;
	display: flex;
	gap: 12px;
`;

export const ActionItemsContainer = styled.section`
	padding: 25px 23px;
	padding-bottom: 0px;
	background-color: #fff;
	position: relative;
	.ant-collapse {
		background-color: #fff;
	}

	.ant-collapse-item {
		margin-bottom: 16px;
	}

	.ant-collapse-header {
		background-color: #f2f6fa;
		font-weight: bold;
	}

	.ant-collapse-header-text {
		color: #2e333e;
		font-size: 16px; 
	}

	.ant-collapse-content-box {
		background-color: #fff;
		margin-top: 15px;
	}

	.ant-select-selection-placeholder {
		color: #2e333e;
	}

	#ec-status-container .passive .ant-select-selection-item {
		color: #ff4e4e;
		font-weight: bold;
	}

	#ec-status-container .active .ant-select-selection-item {
		color: #5fbe2d;
		font-weight: bold;
	}
`;

export const MessageBox = styled.div`
	margin-top: 12px;
	padding: 12px 14px;
	border-radius: 8px;
	font-size: 13px;
	line-height: 1.5;
	max-height: 200px;
	overflow-y: auto;
`;

export const WarningMessageBox = styled(MessageBox)`
	background-color: #fff2f0;
	border: 1px solid #ffccc7;
	color: #a8071a;
`;

export const InfoMessageBox = styled(MessageBox)`
	background-color: #fffbe6;
	border: 1px solid #ffe58f;
	color: #ad6800;
`;

export const FormHeaderComponent = styled.div`
	font-size: clamp(18px, 1.5vw, 24px);
	font-weight: 600;
	line-height: 1.4;
	text-align: left;
	text-wrap: balance;
	overflow-wrap: anywhere;
	padding-left: 16px;
	border-left: 4px solid #f4511e;
	position: relative;
	color: #1a202c;
	margin-bottom: 24px;
	font-family: "Roboto", "Roboto-Medium" !important;
`;
